import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';

/*
 * Import React Router API in this way to minimize bundle size.
 * (https://github.com/ReactTraining/react-router/blob/v3/docs/guides/MinimizingBundleSize.md)
 */
import browserHistory from 'react-router/lib/browserHistory';
import applyRouterMiddleware from 'react-router/lib/applyRouterMiddleware';
import RouterContext from 'react-router/lib/RouterContext';
import Router from 'react-router/lib/Router';
import { useScroll } from 'react-router-scroll';

/*
 * Used to configure the `react-router-scroll` middleware so that going
 * between slides does not scroll the page to the top!
 *
 * Only exported for unit testing.
 *
 * Relevant documentation:
 * https://github.com/taion/react-router-scroll#custom-scroll-behavior
 */
export const shouldUpdateScroll = (prevRouterProps, { location }) =>
  !prevRouterProps || location.pathname !== prevRouterProps.location.pathname;

export default function getContainerElement(store, options = {}) {
  const {
    serverSideRouterProps,
    clientSideRouterProps
  } = options;

  let AppRouter;

  if (typeof serverSideRouterProps !== 'undefined') {
    AppRouter = <RouterContext {...serverSideRouterProps} />;
  } else {
    AppRouter = (
      <Router
        history={browserHistory}
        render={applyRouterMiddleware(useScroll(shouldUpdateScroll))}
        {...clientSideRouterProps}
      />
    );
  }

  return (
    <ReduxProvider store={store}>
      {AppRouter}
    </ReduxProvider>
  );
}
